import React from 'react';
import { default as ReactSelect } from 'react-select';
import classNames from 'classnames';
import {
  Control,
  MultiValue,
  Input,
  Placeholder,
  SingleValue,
} from './SelectComponents';

export interface SelectProps {
  value?: unknown;
  options: unknown[];
  id?: string;
  isMulti?: boolean;
  controlClassName?: string;
  containerClassName?: string;
  placeholder?: string;
  onChange?: (options: unknown) => void;
}

export const Select: React.FC<SelectProps> = ({
  options,
  id,
  controlClassName,
  containerClassName,
  placeholder,
  onChange,
  value,
  isMulti = true,
}) => {
  return (
    <ReactSelect
      id={id}
      isMulti={isMulti}
      isClearable
      value={value}
      onChange={onChange}
      className={classNames('select-container', containerClassName)}
      classNamePrefix="select"
      placeholder={placeholder}
      options={options}
      components={{
        Control: ({ children, ...rest }) => (
          <Control
            {...rest}
            className={classNames(rest.className, controlClassName)}
          >
            {children}
          </Control>
        ),
        Placeholder,
        SingleValue,
        MultiValue,
        Input,
        IndicatorSeparator: null,
      }}
    />
  );
};
